export enum MembershipSlug {
    LIFETIME_UNLIMITED = 'lifetime-unlimited',
    LIFETIME_FACULTY = 'lifetime-faculty',
    LIFETIME_BASIC = 'lifetime-basic',
    LIFETIME_STANDARD = 'lifetime-standard',
    LIFETIME_GIFT = 'lifetime-gift',
    GIFT_PREMIUM = 'gift-premium'
  };

export enum LifetimeSlug {
    LIFETIME_UNLIMITED = 'lifetime-unlimited',
    LIFETIME_FACULTY = 'lifetime-faculty',
    LIFETIME_BASIC = 'lifetime-basic',
    LIFETIME_STANDARD = 'lifetime-standard',
    LIFETIME_GIFT = 'lifetime-gift',
  };
